import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Clock } from 'lucide-react';
import { MobileSubMenuHeader } from '@/components/layout';
import { navigationItems } from '@/lib/navigation';

interface TimesheetProps {
  isGlobalDarkMode?: boolean;
  onMobileSubMenuToggle?: (menuId: string | null, subItems?: any[], menuLabel?: string) => void;
  isMobile?: boolean;
}

export default function Timesheet({ isGlobalDarkMode = true, onMobileSubMenuToggle, isMobile = false }: TimesheetProps) {
  const [mobileSearchQuery, setMobileSearchQuery] = React.useState('');

  const handleMobileMenuToggle = () => {
    const boardsMenuItem = navigationItems.find(item => item.id === 'boards');
    if (boardsMenuItem && onMobileSubMenuToggle) {
      onMobileSubMenuToggle('boards', boardsMenuItem.subItems, boardsMenuItem.label);
    }
  };

  const handleMobileAdd = () => {
    alert('Log new time (coming soon)');
  };

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Timesheet | AgencyPlus</title>
        <link rel="canonical" href="/boards/time-tracker" />
      </Helmet>

      {isMobile && (
        <MobileSubMenuHeader
          onMenuClick={handleMobileMenuToggle}
          onAddClick={handleMobileAdd}
          searchValue={mobileSearchQuery}
          onSearchChange={setMobileSearchQuery}
          searchPlaceholder="Search time logs..."
          showSearch={true}
          showAdd={true}
          isDarkMode={isGlobalDarkMode}
        />
      )}

      <div className={`max-w-7xl mx-auto p-8 ${isMobile ? 'pt-20' : ''}`}>
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-foreground">
            Timesheet
          </h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Log and manage your team's billable hours
          </p>
        </div>

        <div className="flex items-center justify-center min-h-[500px]">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-20 h-20 rounded-full mb-6 bg-workspace-accent/15">
              <Clock className="w-10 h-10 text-workspace-accent" />
            </div>

            <h2 className="text-2xl font-semibold mb-4 text-foreground">
              Coming Soon
            </h2>

            <p className="max-w-md mx-auto text-muted-foreground">
              We're building a comprehensive timesheet tool to help you log hours, track billable time, and generate detailed reports.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
